import { render, staticRenderFns } from "./data-view.vue?vue&type=template&id=10bf57a4&scoped=true"
import script from "./data-view.vue?vue&type=script&lang=js"
export * from "./data-view.vue?vue&type=script&lang=js"
import style0 from "./data-view.vue?vue&type=style&index=0&id=10bf57a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bf57a4",
  null
  
)

export default component.exports